import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Icon from '../../../../components/forms/icon.component';

interface MenuBarProps {
  options: Array<{ label: string; value: number }>;
  selected: { label: string; value: number };
  onEnvChange: (opt: { label: string; value: number }) => void;
  onOpenPreview: () => void;
  onPublish: () => void;
}

const MenuBar: React.FC<MenuBarProps> = ({
  options,
  selected,
  onEnvChange,
  onOpenPreview,
  onPublish
}) => {
  const { t } = useTranslation();
  const error = false;

  return (
    <div className="flows-menu-bar d-flex align-items-center px-4 py-1 bg-light border-bottom">
      {/* Selector de ambiente */}
      <Icon
        icon="ki-abstract-27"
        size="fs-1"
        className="hover-icon"
        type={selected.value === 1 ? 'danger' : 'primary'}
      />
      <Select
        options={options}
        value={selected}
        onChange={(opt) => opt && onEnvChange(opt)}
        className={error ? 'form-select-custom is-invalid' : 'form-select-custom' + ' ms-3'}
        classNamePrefix="form-select-custom"
        isSearchable={false}
        styles={{ container: (base) => ({ ...base, width: 150 }) }}
      />

      <div className="vr ms-2 me-4" />

      {/* Botón Probar */}
      <div className="d-flex align-items-center me-4 cursor-pointer" onClick={onOpenPreview}>
        <Icon icon="ki-to-right " size="fs-1" className="hover-icon" type="info" />
        <span className="ms-1 fw-bold">{t('flows.menu.test', 'Probar')}</span>
      </div>
      <span className="text-info fw-bolder ms-1 me-4">|</span>
      {/* Botón Publicar */}
      <div className="d-flex align-items-center cursor-pointer" onClick={onPublish}>
        <Icon icon="ki-send" size="fs-2" className="hover-icon" type="primary" />
        <span className="ms-1 fw-bold">{t('flows.menu.publish', 'Publicar')}</span>
      </div>
    </div>
  );
};

export default MenuBar;
